import listable from "@/mixins/listable";

export default {
  mixins: [listable],
  data() {
    return {
      items: [],
      selection: [],
      activeId: null,
      isOpenView: false,
      isOpenRemove: false,
      isOpenEditing: false,
      isOpenCreation: false,
      isOpenBulkCreation: false,
      isOpenBulkRemove: false,
      isSelectAll: false
    };
  },
  methods: {
    openView(id) {
      if (typeof this.trackAction == "function") {
        this.trackAction("open-view");
      }

      this.isOpenView = true;
      this.activeId = id;
    },
    closeView() {
      if (typeof this.trackAction == "function") {
        this.trackAction("close-view");
      }

      this.isOpenView = false;
      this.activeId = null;
    },
    openCreation() {
      if (typeof this.trackAction == "function") {
        this.trackAction("open-creation");
      }

      this.isOpenCreation = true;
    },
    closeCreation() {
      if (typeof this.trackAction == "function") {
        this.trackAction("close-creation");
      }

      this.isOpenCreation = false;
      this.activeId = null;
    },
    openEditing(id) {
      if (typeof this.trackAction == "function") {
        this.trackAction("open-editing");
      }

      this.isOpenEditing = true;
      this.activeId = id;
    },
    closeEditing() {
      if (typeof this.trackAction == "function") {
        this.trackAction("close-editing");
      }

      this.isOpenEditing = false;
      this.activeId = null;
    },
    openRemoving(id) {
      if (typeof this.trackAction == "function") {
        this.trackAction("open-removing");
      }

      this.isOpenRemove = true;
      this.activeId = id;
    },
    openBulkRemoving() {
      if (typeof this.trackAction == "function") {
        this.trackAction("open-bulk-removing");
      }

      this.isOpenBulkRemove = true;
    },
    closeRemoving() {
      if (typeof this.trackAction == "function") {
        this.trackAction("close-removing");
      }

      this.isOpenRemove = false;
      this.activeId = null;
    },
    closeBulkRemoving() {
      if (typeof this.trackAction == "function") {
        this.trackAction("close-bulk-removing");
      }

      this.isOpenBulkRemove = false;
      this.selection = [];
      this.isSelectAll = false;
    },
    openBulkCreation() {
      if (typeof this.trackAction == "function") {
        this.trackAction("open-bulk-creation");
      }

      this.isOpenBulkCreation = true;
    },
    closeBulkCreation() {
      if (typeof this.trackAction == "function") {
        this.trackAction("close-bulk-creation");
      }

      this.isOpenBulkCreation = false;
      this.activeId = null;
    },
    getData() {
      if (typeof this.dataAction !== "function") {
        return;
      }

      let params = this.params;

      if (typeof this.dataActionData === "function") {
        params._data = this.dataActionData();
      }

      if (typeof this.dataActionParams === "function") {
        params = { ...params, ...this.dataActionParams() };
      }

      return this.$store.dispatch(this.dataAction(), params).then(() => {
        if (typeof this.track == 'function') {
          this.track();
        }
      });
    },
    remove(id) {
      this.$store.dispatch(this.removeAction(), { id }).then(() => {
        if (typeof this.trackAction == "function") {
          this.trackAction("remove");
        }
        this.removed();
      });
    },
    bulkRemove(ids) {
      this.$store.dispatch(this.bulkRemoveAction(), { ids }).then(() => {
        if (typeof this.trackAction == "function") {
          this.trackAction("bulk-remove");
        }
        this.bulkRemoved();
      });
    },
    duplicate(id) {
      if (
        typeof this.duplicateAction !== "function" ||
        !this.duplicateAction()
      ) {
        return;
      }

      this.$store.dispatch(this.duplicateAction(), { id }).then(() => {
        if (typeof this.trackAction == "function") {
          this.trackAction("duplicate");
        }

        this.duplicated();
      });
    },
    failed(response) {
      const message =
        response && response.message
          ? response.message
          : this.$lang("main.crud.something_went_wrong");
      this.showNotification(message, "error");
    },
    selectAll() {
      this.selection = this.collection.map((item) => item.id);
    },
    deselectAll() {
      this.selection = [];
    },
    created(response) {
      if (typeof this.trackAction == "function") {
        this.trackAction("created");
      }
      this.getData();
      this.closeCreation();
      this.showNotification(this.$lang("main.crud.success_create"), "success");
      this.$emit("refreshParent");
    },
    updated(response) {
      if (typeof this.trackAction == "function") {
        this.trackAction("updated");
      }
      this.getData();
      this.closeEditing();
      this.showNotification(this.$lang("main.crud.success_update"), "success");
      this.$emit("refreshParent");
    },
    removed(response) {
      if (typeof this.trackAction == "function") {
        this.trackAction("removed");
      }
      this.getData();
      this.closeRemoving();
      this.showNotification(this.$lang("main.crud.success_remove"), "success");
      this.$emit("refreshParent");
    },
    bulkRemoved(response) {
      if (typeof this.trackAction == "function") {
        this.trackAction("bulk-removed");
      }
      this.getData();
      this.closeBulkRemoving();
      this.showNotification(this.$lang("main.crud.success_remove"), "success");
      this.$emit("refreshParent");
    },
    bulkCreated(response) {
      if (typeof this.trackAction == "function") {
        this.trackAction("bulk-create");
      }
      this.getData();
      this.closeBulkCreation();
      this.showNotification(this.$lang("main.crud.success_create"), "success");
      this.$emit("refreshParent");
    },
    duplicated(response) {
      if (typeof this.trackAction == "function") {
        this.trackAction("duplicated");
      }
      this.getData();
      this.showNotification(
        this.$lang("main.crud.success_duplicate"),
        "success"
      );
      this.$emit("refreshParent");
    },
    createdThenEdit(response) {
      this.getData();
      this.closeCreation();
      if (!!response.id) {
        this.openEditing(response.id);
      }
    }
  }
};
